export default "__VITE_ASSET__Bdb$1GbL__"